import type { FunctionComponent } from 'react';

import Icon, { icons } from '../Icon';
import Link from '../Link/Link';
import type { LinkProps } from '../Link/Link';

import styles from './DetailsPanel.module.less';

/**
 * DetailsPanelLink serves as a simple wrapper around
 * the Link component which includes an external link icon.
 * The styles ensure that the link looks like it belongs in
 * the DetailsPanel row.
 */
const DetailsPanelLink: FunctionComponent<LinkProps> = ({ to, children, ...rest }) => (
  <Link
    to={to}
    className={styles.link}
    openInNewTab
    {...rest}
  >
    {children}
    <span className={styles.linkIcon}>
      <Icon icon={icons.externalLink} />
    </span>
  </Link>
);

export default DetailsPanelLink;
